import React from "react";
import { motion, AnimatePresence } from "framer-motion";

interface ModalCenterSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  backgroundUrl?: string;
}

const ModalCenterSheet: React.FC<ModalCenterSheetProps> = ({ open, onClose, children, backgroundUrl }) => (
  <AnimatePresence>
    {open && (
      <div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40 overflow-hidden"
        onClick={onClose}
      >
        <motion.div
          className="bg-gray-800 shadow-lg max-w-md w-full rounded-2xl m-4"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.25 }}
          onClick={e => e.stopPropagation()}
          style={{
            backgroundImage: `url(${backgroundUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          {children}
        </motion.div>
      </div>
    )}
  </AnimatePresence>
);

export default ModalCenterSheet; 
